import { render } from "./system-settings.vue?vue&type=template&id=1fa74420&scoped=true"
import script from "./system-settings.vue?vue&type=script&lang=js"
export * from "./system-settings.vue?vue&type=script&lang=js"

import "./system-settings.vue?vue&type=style&index=0&id=1fa74420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa74420"]])

export default __exports__